"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getRequestStatus = getRequestStatus;
exports.getRequests = getRequests;

var _values = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/values"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/toConsumableArray"));

var _constants = require("../constants");

var _converters = require("../utilities/converters");

var _language = require("../utilities/language");

function getRequests(state, filter) {
  if ((0, _language.isNil)(state)) {
    return [];
  }

  var requests = state.requests;

  if ((0, _language.isArray)(filter)) {
    return filter.reduce(function (previousValue, requestKey) {
      if (!(0, _language.hasOwnProperty)(requests, requestKey)) {
        return previousValue;
      }

      return [].concat((0, _toConsumableArray2.default)(previousValue), [requests[requestKey]]);
    }, []);
  }

  if ((0, _language.isFunction)(filter)) {
    return (0, _values.default)(requests).filter(function (request) {
      return filter(request, state);
    });
  }

  return (0, _values.default)(requests);
}

function getRequestStatus(state, requestKey) {
  var _ref = state.requests[requestKey] || {},
      _ref$requestStatus = _ref.requestStatus,
      requestStatus = _ref$requestStatus === void 0 ? _constants.readyState.IDLE : _ref$requestStatus;

  return (0, _converters.statusObjectFromRequestStatus)(requestStatus);
}